import { IconButton, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing, Typography } from '@genial/design-tokens';
import { Skeleton } from 'native-base';
import React from 'react';

import { TableContent } from '../../../../components/TableContent';

interface SkeletonItemTabletProps {}

export const SkeletonItemTablet: React.FC<SkeletonItemTabletProps> = () => {
  return (
    <TableContent direction="row" p={Spacing['inline.xxxs']}>
      <VStack space={Spacing['inline.nano']} w="full">
        <HStack alignItems="center" justifyContent="space-between">
          <Skeleton
            maxW="20%"
            h={Typography['fontsize.lg']}
            borderRadius={BoxRadius.sm}
            flex={1}
            endColor={Color['brand.primary.lightest']}
          />
          <HStack space={Spacing['inline.nano']} alignItems="center">
            <Skeleton
              w={Spacing['inline.xxs']}
              h={Spacing['inline.xxs']}
              borderRadius={BoxRadius.circular}
              endColor={Color['brand.primary.lightest']}
            />
            <Skeleton
              flex={1}
              maxW="80px"
              w="80px"
              h={Typography['fontsize.lg']}
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />
          </HStack>
        </HStack>
        <HStack justifyContent="space-between" alignItems="center">
          <VStack space={Spacing['stack.quarck']} flex={1} maxW="100px">
            <Skeleton
              w="100%"
              h={Typography['fontsize.lg']}
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />
            <Skeleton
              w="80%"
              h={Typography['fontsize.lg']}
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />
          </VStack>
          <VStack space={Spacing['stack.quarck']} flex={1} maxW="70px">
            <Skeleton
              w="50%"
              h={Typography['fontsize.lg']}
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />
            <Skeleton
              w="100%"
              h={Typography['fontsize.lg']}
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />
          </VStack>
          <VStack space={Spacing['stack.quarck']} flex={1} maxW="50px">
            <Skeleton
              w="100%"
              h={Typography['fontsize.lg']}
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />
            <Skeleton
              w="100%"
              h={Typography['fontsize.lg']}
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />
          </VStack>
          <VStack space={Spacing['stack.quarck']} flex={1} maxW="50px">
            <Skeleton
              w="100%"
              h={Typography['fontsize.lg']}
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />
            <Skeleton
              w="100%"
              h={Typography['fontsize.lg']}
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />
          </VStack>
          <VStack space={Spacing['stack.quarck']} flex={1} maxW="86px">
            <Skeleton
              w="100%"
              h={Typography['fontsize.lg']}
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />
            <Skeleton
              w="80%"
              h={Typography['fontsize.lg']}
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />
          </VStack>
          <VStack space={Spacing['stack.quarck']} flex={1} maxW="126px">
            <Skeleton
              w="80%"
              h={Typography['fontsize.lg']}
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />
            <Skeleton
              w="100%"
              h={Typography['fontsize.lg']}
              borderRadius={BoxRadius.sm}
              endColor={Color['brand.primary.lightest']}
            />
          </VStack>
          <IconButton
            isDisabled
            testId="arrow-right"
            icon="ArrowRight"
            iconColor={Color['neutral.light']}
          />
        </HStack>
      </VStack>
    </TableContent>
  );
};
